import ForecastItem from "./forecast-item";

const ForecastWidget: React.FC<{ title: string; data: types.ForecastInfo }> = ({
  title,
  data,
}) => {
  return (
    <div className="absolute inset-0 z-10 flex justify-end">
      <div className="bg-black/35 backdrop-blur-xl px-8 py-6 min-h-screen md:px-20 md:py-10">
        {/* Header - гарчиг хэсэг */}
        <header className="text-right mb-8">
          <h1 className="text-white font-bold text-3xl md:text-5xl">{title}</h1>
          <p className="text-gray-300 text-lg md:text-xl italic mt-2">
            Урьдчилсан {data.forecast.length} хоногийн мэдээ
          </p>
        </header>

        {/* Table header - хүснэгтийн гарчиг */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-white text-sm md:text-xl font-semibold border-b border-white pb-3 mb-4">
          <div className="col-span-2 md:col-span-1">Өдөр</div>
          <div className="text-center">Шөнө</div>
          <div className="text-center">Өдөр</div>
          <div className="text-center hidden md:block">Нар мандах</div>
          <div className="text-center hidden md:block">Нар жаргах</div>
        </div>

        {/* Forecast items - урьдчилсан мэдээний жагсаалт */}
        <div className="space-y-4">
          {data.forecast.map((item, index) => (
            <ForecastItem key={`${item.date}-${index}`} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};
export default ForecastWidget;
